import React, { useState } from "react";
import { Modal, Button, Spin } from "antd";
import { BlackXIcon, DeleteInformation } from "../../../assets/icons";
import { httpService } from "../../../base/services/httpService.service";
import { useTranslation } from "../../../i18n/LanguageContext";

const DeleteTicketModal = ({
   visible,
   onCancel,
   onOk,
   // loading,
   selectedRowKeys,
   setDeleteTickets,
   notificationApi,
   fetchData,
   pagination
}) => {
   const { t } = useTranslation();
   const [loading, setLoading] = useState(false);

   const handleDelete = async () => {
      try {
         setLoading(true);
         await httpService.delete("/Tickets/delete-tickets", selectedRowKeys);
         setDeleteTickets(false);
         notificationApi.success("ticket", {
            message: t("tickets-deleted-success-title"),
            description: t("tickets-deleted-success-description")
         });
         fetchData(pagination);
      } catch (error) {
         setDeleteTickets(false);
         notificationApi.error("ticket", {
            message: t("toast-oops-title"),
            description: t("delete-tickets-error-description")
         });
      } finally {
         setLoading(false);
      }
   };

   return (
      <Modal
         open={visible}
         onCancel={onCancel}
         onOk={handleDelete}
         maskClosable={!loading}
         closable={false}
         className="deletemembermodal"
         footer={[
            <div className="footer-buttons" key="uniqueKey">
               <Button
                  className="cencel-delete-button"
                  key="cancel"
                  onClick={loading ? null : onCancel}
                  disabled={loading}
               >
                  {t("cancel")}
               </Button>
               <Button
                  className="delete-button"
                  key="error"
                  type="primary"
                  danger
                  onClick={handleDelete}
                  disabled={loading}
               >
                  {loading ? <Spin /> : t("delete-button")}
               </Button>
            </div>
         ]}
      >
         <div>
            <img
               src={BlackXIcon}
               alt="BlackXIcon"
               onClick={loading ? null : onCancel}
               style={{ float: "right", cursor: "pointer" }}
            />
            <div className="delete-member-modal">
               <img src={DeleteInformation} alt="DeleteInformation" />
               <h1 className="delete-title">{t("delete-selected-tickets-title")}</h1>
            </div>
            <p className="delete-description">
               <div>
                  {t("delete-selected-tickets-confirm-text")}{" "}
                  <span> {t("confirm-continue-text")}</span>
               </div>
            </p>
         </div>
      </Modal>
   );
};

export default DeleteTicketModal;
